import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { Comment } from "./comment.model";
import { UserService } from "src/app/_services";
import { BehaviorSubject } from "rxjs";
import { OrderType } from "../../../_types";
const url = environment.api;

@Injectable({
  providedIn: "root",
})
export class CommentService {
  constructor(private http: HttpClient, private userServ: UserService) {
    this.comments = [];
  }

  comment: Comment = new Comment();
  comments: Comment[] = [];
  commentsBehavior = new BehaviorSubject(this.comments);

  getComments() {
    return this.http.get<Comment[]>(url + "comment");
  }

  getComment(commentId: string) {
    return this.http.get<Comment>(url + "comment/" + commentId);
  }

  getCommentsFilterBy(
    tableName: string,
    idTableObject: number,
    order: OrderType = OrderType.DESC
  ) {
    return this.http.get(
      `${url}comment?tableName=${tableName}&idTableObject=${idTableObject}&order=${order}`
    );
  }

  createComment(
    tableName: string,
    idTableObject: number,
    commentContent: string,
    automaticallyGenerated = false
  ) {
    this.comment.tableName = tableName;
    this.comment.idTableObject = idTableObject;
    this.comment.idUserCreated = this.userServ.userStorage.id;
    this.comment.content = commentContent;
    this.comment.automaticallyGenerated = automaticallyGenerated;

    return this.http.post(url + "comment", this.comment);
  }



  updateComment() {
    return this.http.put(url + "comment/" + this.comment.id, this.comment);
  }

  deleteComment(commentId: number) {
    return this.http.delete(url + "comment/" + commentId);
  }
}
